var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _Images_onAnyImageLoadedCallback, _Images_create3DArray, _Images_onAnyImageLoaded, _Images_clearNotRelevantTilesOnLevel, _Images_processQueue;
import { IMAGE_EXTENSION, LOADING_QUEUE_LIMIT, MAX_IMAGES_PER_FRAME_IDLE, MAX_IMAGES_PER_FRAME_WHILE_ANIM, } from '../consts';
export class Images {
    constructor(tilesUrl, layers, viewport) {
        Object.defineProperty(this, "TILES_URL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "loadedImages3D", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "loading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "queue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "viewport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _Images_onAnyImageLoadedCallback.set(this, null);
        _Images_create3DArray.set(this, (layers) => {
            layers.forEach((layer) => {
                const levelArr = [];
                for (let y = 0; y < layer.countY; y++) {
                    const row = [];
                    row.length = layer.countX;
                    row.fill(null);
                    levelArr.push(row);
                }
                this.loadedImages3D[layer.id] = levelArr;
            });
        });
        _Images_onAnyImageLoaded.set(this, () => {
            if (__classPrivateFieldGet(this, _Images_onAnyImageLoadedCallback, "f"))
                __classPrivateFieldGet(this, _Images_onAnyImageLoadedCallback, "f").call(this);
        });
        Object.defineProperty(this, "loadAndAddImageIfNotExist", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (level, posX, posY, hasOnLoadCallback = false) => {
                if (!this.loadedImages3D[level][posY][posX]) {
                    this.loadImage(`${this.TILES_URL}/${level}/${posX}_${posY}.${IMAGE_EXTENSION}`, level, posX, posY).then((image) => {
                        if (image) {
                            this.loadedImages3D[level][posY][posX] = image;
                            if (hasOnLoadCallback) {
                                __classPrivateFieldGet(this, _Images_onAnyImageLoaded, "f").call(this);
                            }
                        }
                    });
                }
            }
        });
        _Images_clearNotRelevantTilesOnLevel.set(this, (level, fromX, fromY, toX, toY) => {
            for (let i = 0; i < fromY; i++) {
                this.loadedImages3D[level][i].fill(null);
            }
            for (let i = toY + 1; i < this.loadedImages3D[level].length; i++) {
                this.loadedImages3D[level][i].fill(null);
            }
            for (let i = fromY; i <= toY; i++) {
                for (let x = 0; x < fromX; x++) {
                    this.loadedImages3D[level][i][x] = null;
                }
                for (let x = toX + 1; i < this.loadedImages3D[level].length; i++) {
                    this.loadedImages3D[level][i][x] = null;
                }
            }
        });
        Object.defineProperty(this, "setOnAnyImageLoadedCallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (cb) => {
                __classPrivateFieldSet(this, _Images_onAnyImageLoadedCallback, cb, "f");
            }
        });
        Object.defineProperty(this, "getLoadedImageByTilePosition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (level, x, y, forceLoad = false) => {
                if (forceLoad) {
                    this.loadAndAddImageIfNotExist(level, x, y);
                }
                return this.loadedImages3D[level][y][x];
            }
        });
        Object.defineProperty(this, "clearLevel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (level) => {
                if (level !== 0 && this.loadedImages3D?.[level]) {
                    this.loadedImages3D[level].forEach((_, index) => this.loadedImages3D[level][index].fill(null));
                }
            }
        });
        Object.defineProperty(this, "loadImagesByTilesNames", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (level, fromX, fromY, toX, toY) => {
                if (this.loadedImages3D?.[level]) {
                    __classPrivateFieldGet(this, _Images_clearNotRelevantTilesOnLevel, "f").call(this, level, fromX, fromY, toX, toY);
                    for (let y = fromY; y <= toY; y++) {
                        for (let x = fromX; x <= toX; x++) {
                            this.loadAndAddImageIfNotExist(level, x, y, true);
                        }
                    }
                }
            }
        });
        Object.defineProperty(this, "loadImage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (url, level, posX, posY) => {
                return new Promise((resolve) => {
                    if (this.queue.length > LOADING_QUEUE_LIMIT) {
                        this.queue.shift();
                    }
                    this.queue.push({ url, resolve, level, posX, posY });
                    if (!this.loading) {
                        this.loading = true;
                        requestAnimationFrame(__classPrivateFieldGet(this, _Images_processQueue, "f"));
                    }
                });
            }
        });
        _Images_processQueue.set(this, () => {
            const slicer = this.viewport.isZooming ? MAX_IMAGES_PER_FRAME_WHILE_ANIM : MAX_IMAGES_PER_FRAME_IDLE;
            const batch = this.queue.splice(this.queue.length - 1 - slicer, slicer);
            Promise.all(batch.map(({ url, level, posX, posY }) => {
                if (level && posX && posY && this.loadedImages3D[level][posY][posX]) {
                    return null;
                }
                else {
                    return new Promise((innerResolve) => {
                        const image = new Image();
                        image.onload = () => {
                            innerResolve(image);
                        };
                        image.onerror = () => {
                            console.error('error loading image', url);
                        };
                        image.src = url;
                    });
                }
            }))
                .then((loadedImages) => {
                loadedImages.forEach((loadedImage, index) => {
                    batch[index].resolve(loadedImage);
                });
                if (this.queue.length > 0) {
                    requestAnimationFrame(__classPrivateFieldGet(this, _Images_processQueue, "f"));
                }
                else {
                    this.loading = false;
                }
            })
                .catch((error) => {
                console.error('processQueue error', error);
            });
        });
        this.TILES_URL = tilesUrl;
        __classPrivateFieldGet(this, _Images_create3DArray, "f").call(this, layers);
        this.loading = false;
        this.viewport = viewport;
    }
}
_Images_onAnyImageLoadedCallback = new WeakMap(), _Images_create3DArray = new WeakMap(), _Images_onAnyImageLoaded = new WeakMap(), _Images_clearNotRelevantTilesOnLevel = new WeakMap(), _Images_processQueue = new WeakMap();
